<template>
    <VehicleField type="checkbox" :vehicle="vehicle" :field="field" />
</template>

<script>
import VehicleField from '~/components/vehicle/VehicleField';

export default {
    components: {
        VehicleField,
    },
    props: {
        vehicle: {
            type: Object,
            default: () => {},
        },
        field: {
            type: String,
            default: '',
        },
    },
};
</script>
